import { useMutation, useQuery } from "@tanstack/react-query";
import client from "./client";
import { useNotifications } from "reapop";
import { useNavigate } from "react-router-dom";
import { queryClient } from "queryclient";


export const CreateChemicalSynthesisMutation = () => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const createChemicalSynthesis = useMutation({
    mutationFn: (data) =>
      client.chemicalSynthesis.createCustomChemicalSynthesis(data),
    onSuccess: () => {
      notify("Data Added Successfully", "success");
      navigate("/chemical-synthesis");
      queryClient.invalidateQueries({
        queryKey: ["fetch-custom-chemical-synthesis"],
      });
    },
    onError: () => {
      notify("OOPS! some error occured", "error");
    },
  });
  return createChemicalSynthesis;
};

export const GetCustomChemicalSynthesisMutation = () => {
  const getChemicalSynthesis = useQuery({
    queryKey: ["fetch-custom-chemical-synthesis"],
    queryFn: () => client.chemicalSynthesis.getCustomChemicalSynthesis(),
  });
  return getChemicalSynthesis;
};

export const GetSingleChemicalSynthesisMutation = (data) => {
  const getSingleChemicalSynthesis = useQuery({
    queryKey: ["fetch-single-chemical-synthesis"],
    queryFn: () => client.chemicalSynthesis.getSingleChemicalSynthesis(data),
  });
  return getSingleChemicalSynthesis;
};

export const UpdateChemicalSynthesisMutation = () => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const updateChemicalSynthesis = useMutation({
    mutationFn: (data) =>
      client.chemicalSynthesis.updateCustomChemicalSynthesis(data),
    onSuccess: () => {
      notify("Data Updated Successfully", "success");
      navigate("/chemical-synthesis");
      queryClient.invalidateQueries({
        queryKey: ["fetch-custom-chemical-synthesis"],
      });
    },
    onError: () => {
      notify("OOPS! some error occured", "error");
    },
  });
  return updateChemicalSynthesis;
};

export const DeleteChemicalSynthesisMutation = () => {
  const { notify } = useNotifications();
  const deleteChemicalSynthesis = useMutation({
    mutationFn: (data) =>
      client.chemicalSynthesis.deleteCustomChemicalSynthesis(data),
    onSuccess: () => {
      notify("Data Deleted Successfully", "success");
      queryClient.invalidateQueries({
        queryKey: ["fetch-custom-chemical-synthesis"],
      });
    },
    onError: () => {
      notify("OOPS! some error occured", "error");
    },
  });
  return deleteChemicalSynthesis;
};

// experties-include

export const CreateExpertiesIncludesMutation = () => {
  const { notify } = useNotifications();
  const expertiesIncludes = useMutation({
    mutationFn: (data) => client.chemicalSynthesis.expertiseIncludes(data),
    onSuccess: () => {
      notify("Data Added Successfully", "success");
      queryClient.invalidateQueries({
        queryKey: ["fetch-experties-includes"],
      });
    },
    onError: () => {
      notify("OOPS! some error occured", "error");
    },
  });
  return expertiesIncludes;
};

export const GetExpertiesIncludesMutation = () => {
  const getExpertiesIncludesMutation = useQuery({
    queryKey: ["fetch-experties-includes"],
    queryFn: () => client.chemicalSynthesis.getExpertiseIncludes(),
  });
  return getExpertiesIncludesMutation;
};

export const GetCcsExploreHeading = () => {
  return useQuery({
    queryKey: ["get-ccs-explore-heading"],
    queryFn: () => client.chemicalSynthesis.getCcsExploreHeading(),
  });
};

export const UpdateCcsExploreHeading = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.chemicalSynthesis.updateCcsExploreHeading(data),
    onSuccess: () => {
      notify("Heading updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-ccs-explore-heading"] });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
};

export const GetAllCcsExploreLinks = () => {
  return useQuery({
    queryKey: ["get-ccs-explore-links"],
    queryFn: () => client.chemicalSynthesis.getAllCcsExploreLinks(),
  });
};

export const CreateCcsExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.chemicalSynthesis.newCcsExploreLink(data),
    onSuccess: () => {
      notify("Link added successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-ccs-explore-links"] });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
};

export const UpdateCcsExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.chemicalSynthesis.updateCcsExploreLink(data),
    onSuccess: () => {
      notify("Link updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-ccs-explore-links"] });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
};

export const DeleteCcsExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.chemicalSynthesis.deleteCcsExploreLink(data),
    onSuccess: () => {
      notify("Link deleted successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-ccs-explore-links"] });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
};
